export default `
  mutation updateCards($projectId: String!, $input: UpdateCardsInput!) {
    updateCards(projectId: $projectId, input: $input) {
      workflowId
      version
      sameAsVersion
      updatedAt
      updateNote {
        userRealName
        action
        target
      }
      cards {
        cardId
        cardIndex
        description
        sortkey
        cardTypeId
        releaseNo
        done
        version
        eventId
        eventIndex
        boundedContext
        creatorId
        creator {
          firstname
          lastname
          id
        }
        schemaId
        tags
      }
    }
  }
`
